define('views/modules/setting/business/blocks/brand/url-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // src
    'services/app-state',
    'services/i18n',
    // views
    'views/parts/form/button',
    'views/parts/form/textbox',
    'views/parts/form/choices',
    'views/parts/form/color-picker',
    'views/parts/info-section',
    'views/parts/modal/image-modal',
    'views/parts/form/file',

    // templates
    'text!templates/modules/setting/business/blocks/brand/url-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    AppState,
    i18n,
    // views
    VButton,
    VTextBox,
    VChoices,
    VColorPicker,
    VInfoSection,
    VImageModal,
    VFile,
    // templates
    TURLEditForm
) {
    // TODO: setup a custom subdomain here (subdomain modal)
    var VBrandEditForm = Backbone.Epoxy.View.extend({
        template: TURLEditForm,

        events: {
            //
        },

        regions: {
            form: {
                url: ".url-text",
                urlPreview: ".url-text-preview",
                backgroundImage: ".background-image",
                backgroundImagePreview: ".background-image-preview"
            }
        },

        initialize: function(opt) {
            this.options = opt || {};

            var view = this.view = {
                info: new VInfoSection({
                    title: "settings:url-title",
                    help: "messages:helpbox-business-custom-url-edit",
                    content: this.template,
                }),
                form: {
                    url: new VTextBox({
                        attribute: 'customUrl',
                        label: "settings:subdomain-title",
                        labelposition: 'top',
                        addon: true,
                        addonAfter: ".totalcoaching.com",
                        model: this.model
                    }),
                    file: new VFile({
                        attribute: 'loginBackgroundImage',
                        label: 'settings:background-image-title',
                        labelposition: "top",
                        context: this,
                        callback: this.onFileChange,
                        model: this.model
                    }),
                    preview: new VButton({
                        label: "settings:background-image-preview",
                        callback: this.onBackgrounImagePreview,
                        context: this,
                        icon: "",
                        target: '_blank',
                        tcClass: false,
                        class: "btn-tc-white"
                    })
                }
            };

            this.listenTo(view.form.url.model, { "change": this._updateTypeInput });
            this.listenTo(view.form.file.model, { "change": this._fileChange });


        },
        render: function() {

            // append the form
            this.assign(this.view.info, this.$el)
                .applyBindings();

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.form.url, zone.form.$url);
            this.assign(view.form.file, zone.form.$backgroundImage);
            this.assign(view.form.preview, zone.form.$backgroundImagePreview);

            if (this.model.get('customUrl')) {
                this._setUrlInputValue(this.model.get('customUrl'), true);
            }

            return this;
        },

        _updateTypeInput: function() {
            var vForm = this.view.form,
                vFormUrl = vForm.url,
                modelCustomUrl = this.model.get('customUrl'),
                customUrlTitle = i18n.t("settings:url-label");

            this._setUrlInputValue(vFormUrl.getValue());

        },

        _setUrlInputValue: function(url, isActive) {
            if (!url) url = this.model.get('customUrl');

            this.view.form.url.setValue(url);

            this._setUrlInputPreview(url, isActive);
        },

        _setUrlInputPreview: function(url, isActive) {
            var customUrlTitle = i18n.t("settings:url-label"),
                showLink = false,
                html = "";

            if (!url) url = this.model.get('customUrl');

            if (url !== "") {
                html += customUrlTitle + " : ";
                if (isActive) html += "<a target='_blank' href='https://" + url + ".totalcoaching.com'>";
                html += "https://" + url + ".totalcoaching.com";
                if (isActive) html += "</a>";

                Backbone.$('.url-text-preview', this.el).html(html);
                this.view.form.preview.toggle(false);
                this.view.form.preview.setUrl("https://" + url + ".totalcoaching.com");
            } else {
                Backbone.$('.url-text-preview', this.el).html("");
                this.view.form.preview.toggle(true);
            }
        },

        _fileChange: function() {
            var vForm = this.view.form,
                vFormFile = vForm.file,
                modelLoginBackgroundImage = this.model.get('loginBackgroundImage');
        },

        _setBackgroundImagePreview: function() {
            this.view.form.preview.toggle(false);
        },

        ////////////
        // events //
        ////////////
        onFileChange: function(file, view) {
            if (view.isImage()) {
                this.model.setBackgroundFile(file);
            }

        },

    });

    return VBrandEditForm;
});

